module.exports = __webpack_public_path__ + "img/JourneyCardScreenshot-1250h.ff7e993e.png";